import React, { ReactElement } from 'react';

import { Dropdown, Loader } from 'ui/patterns';
import { Button } from 'ui/components';

import { useFormDetailsCopy, useUpdateFormStatus } from 'hooks';

import * as Icon from 'assets/icons';

import { confirmAlert } from 'utils/confirm-alert';

import { TableFormOptionsType, FormListOptionType } from './formListType';

export default function TableOptionsHeader(
  props: TableFormOptionsType,
): ReactElement {
  const formId = props.row.original.Id;
  const accountId = props.row.original.AccountId;

  const { mutate: updateFormStatus, isLoading } = useUpdateFormStatus();
  const { mutate: copyForm, isLoading: isFormCopyLoading } =
    useFormDetailsCopy();

  const formsListOptions: FormListOptionType = [
    {
      value: 'Edit Form',
      icon: <Icon.Edit title="" ariaHidden="true" />,
      groupEnd: true,
      action: () => handleEditForm(),
    },
    {
      value:
        props.row.original.SurveyStatus?.Description === 'Disabled'
          ? 'Enable Form'
          : 'Disable Form',
      icon:
        props.row.original.SurveyStatus?.Description === 'Disabled' ? (
          <Icon.CheckCircle title="" ariaHidden="true" />
        ) : (
          <Icon.Ban title="" ariaHidden="true" />
        ),
      groupEnd: true,
      action: () => handleEnableDisableForm(),
    },
  ];

  const copyFormMenuItem = {
    value: 'Copy Form',
    icon: <Icon.Copy title="" ariaHidden="true" />,
    action: () => {
      copyForm({ accountId: accountId, formId: formId });
    },
  };

  if (props.row.original.Account?.CID !== '9000') {
    formsListOptions.push(copyFormMenuItem);
  }

  const handleEnableDisableForm = () => {
    confirmAlert({
      message: <><p>{props.row.original.SurveyStatus?.Description === 'Disabled' ? 'Enabling' : 'Disabling'} this form may reset limited access settings due to changes in lookup questions and custom tables.</p><br /><b>Are you sure you want to {props.row.original.SurveyStatus?.Description === 'Disabled'
        ? 'enable'
        : 'disable'
      } this form?</b></>,
      buttons: [
        {
          label: 'Yes',
          onClick: () => {
            updateFormStatus({
              accountId,
              formId,
              surveyStatus: props.row.original.SurveyStatus?.Description,
            });
          },
          className: 'pr-btn-primary',
        },
        {
          label: 'No',
          onClick: () => {
            //
          },
        },
      ],
    });
  };

  const handleEditForm = (): void => {
    if (props.onEditPress) props.onEditPress(formId);
  };

  const formsListDropdown = () => (
    <Button size="sm">
      <Icon.DotsVertical title="Options" />
    </Button>
  );

  return (
    <>
      <Dropdown
        trigger={formsListDropdown()}
        menuList={formsListOptions}
        position="left-top"
        className="dd-listitem-options"
      />
      {(isLoading || isFormCopyLoading) && <Loader />}
    </>
  );
}
